// extracted by mini-css-extract-plugin
module.exports = {"sportTypeContainer":"SportTypesContainer_sportTypeContainer__jkt1Q","leftArrow":"SportTypesContainer_leftArrow__N08nb","rightArrow":"SportTypesContainer_rightArrow__1Hsuj"};